module.exports = {
  nav: {
    partners: "Partners",
    recruitment: "Recruitment",
    bigEvent: "Big Event",
    home: "Home",
    abount: "About Us",
    ability: "Core Competence",
    businessCase: "Business Case",
    countUs: "Contact Us",
    lang:'EN',
    searchText:'Please enter a keyword',
  },
  home: {
    more: "View more",
    personnel: "Technical personnel",
    serviceFirm: "Service firm",
    project: "Cumulative items",
    client: "Cumulative customers",
    certification: "Certification",
    program: "Industry Solutions",
    advantage: "Our advantage",
    address: "Address",
    url: "URL",
    email: "Email",
    phone: "Contact phone",
    yourMessage:'*Message',
    yourName:'*Your Name',
    yourPhone:'*Phone',
    yourEmail:'*Email',
    cooperation:'Cooperate',
    onTop:'To top',
    countUsTitle:'Create value for our clients with unique full-link talent and technology services!',
  },
  abount:{
    profile:'Company profile',
    culture:'Enterprise culture',
    advantage:'Company advantage',
    team:'Core business',
    qualification:'Honor qualification',
  },
  recruitment:{
    position:'position Name',
    number:'Recruiting Number',
    details:'Details',
    ViewDetails:'View Details',
    Apply:'Apply',
    submit:'Submit'
  }
};



// WEBPACK FOOTER //
// ./src/lang/en.js